import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Seo } from "@/components/site/Seo";
import { PageHero } from "@/components/site/PageHero";
import { Reveal } from "@/components/site/Reveal";
import { CtaBand } from "@/components/site/CtaBand";
import { SERVICES } from "@/data/services";

export default function Services() {
  return (
    <>
      <Seo title="Plumbing Services Sydney – New Builds, Strata | Austyle" description="New builds, strata, maintenance, domestic, commercial and industrial plumbing, blocked drains, hot water and gas fitting across Sydney from Austyle Plumbing." />
      <PageHero testid="services-hero" eyebrow="Services" lines={["Every pipe,", "every property."]} image="/images/projects/beverly-park/kitchen.jpg"
        intro="Domestic, commercial and industrial plumbing — including new builds, strata and maintenance — across Sydney." />
      <section className="bg-porcelain py-20 sm:py-28">
        <div className="container-x">
          <ul className="border-t border-ink/15" data-testid="services-list">
            {SERVICES.map((s, i) => (
              <Reveal as="li" key={s.slug} delay={0.03 * i}>
                <Link to={`/services/${s.slug}`} data-testid={`service-row-${s.slug}`} className="group grid grid-cols-12 items-center gap-4 py-7 sm:py-9 border-b border-ink/15">
                  <span className="col-span-2 sm:col-span-1 font-mono text-xs text-cobalt font-bold">{String(i + 1).padStart(2, "0")}</span>
                  <h2 className="col-span-10 sm:col-span-5 font-wide font-black uppercase text-2xl sm:text-4xl tracking-tight transition-transform duration-500 group-hover:translate-x-2">{s.title}</h2>
                  <p className="col-span-12 sm:col-span-4 text-slate-600 text-sm leading-relaxed">{s.short}</p>
                  <div className="hidden sm:flex col-span-2 justify-end">
                    <div className="relative h-16 w-24 overflow-hidden clip-notch-sm bg-ink">
                      <img src={s.image} alt="" className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-110" />
                    </div>
                  </div>
                  <span className="sm:hidden col-span-12 inline-flex items-center gap-1 text-sm font-bold text-cobalt">View service <ArrowUpRight className="h-4 w-4" /></span>
                </Link>
              </Reveal>
            ))}
          </ul>
        </div>
      </section>
      <CtaBand />
    </>
  );
}
